export default {"src":"/_next/static/media/close-screen.4b36ce4c.svg","height":18,"width":18};